// PGConfigurationView.jsx
import { GetValuesRender } from './commonViews';

import React from 'react';
import PropTypes from 'prop-types';

const PGConfigurationView = props => {
    const { data } = props;
    const { paymentGatewayDtoList } = data;
    return (
        <>
            <div className="checker-section-container">
                <h1 className="checker-section-title">
                    PG Configuration Section Data
                </h1>
                {paymentGatewayDtoList?.map((pg, index) => {
                    const pgStaticData = (({ credentials, ...rest }) => rest)(
                        pg
                    );
                    return (
                        <>
                            <div className="form-section">
                                <GetValuesRender
                                    data={pgStaticData}
                                    isNestedRenderingAllowed
                                />
                            </div>

                            <div className="form-section allow-overflow">
                                <CredentialTable credentials={pg.credentials} />
                            </div>
                        </>
                    );
                })}
            </div>
        </>
    );
};

const CredentialTable = ({ credentials }) => {
    return (
        <table>
            <thead>
                <tr>
                    <th>Status</th>
                    <th>Payment Mode</th>
                    <th>Sub Mode</th>
                    <th>Merchant PG Key</th>
                    <th>Merchant PG Code</th>
                    <th>Security Key</th>
                    <th>Encryption Key</th>
                    <th>Username</th>
                    <th>Password</th>
                    <th>SOAP Key</th>
                </tr>
            </thead>
            <tbody>
                {credentials.map((credential, index) => (
                    <tr key={index}>
                        <td>{credential.status ? 'Active' : 'Inactive'}</td>
                        <td>{credential.paymentType || '-' || '-'}</td>
                        <td>{credential.subMode || '-'}</td>
                        <td>{credential.merchantPGKey || '-'}</td>
                        <td>{credential.merchantPGCode || '-'}</td>
                        <td>{credential.merchantPGSecurityKey || '-'}</td>
                        <td>{credential.encryptionKey || '-'}</td>
                        <td>{credential.username || '-'}</td>
                        <td>{credential.password || '-'}</td>
                        <td>{credential.soapKey || '-'}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

PGConfigurationView.propTypes = {
    data: PropTypes.object,
};

CredentialTable.propTypes = {
    credentials: PropTypes.object,
};

export default PGConfigurationView;
